import Layer from '../../../../Shared/Layer'
import { Trans, withTranslation } from 'react-i18next'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Icon from '../../../../Shared/Icon'
import dayjs from 'dayjs'
import EditImageInformation from '../editImageInformation'
import ImageRoomAssigner from '../../Rooms/ImageRoomAssigner'
import { GALLERIES_SHAPE } from '../../shapes'

class LayerEditImage extends PureComponent {

  render () {
    return (
      this.props.show && this.props.image ?
        <Layer
          type="side" id={'edit_image_' + this.props.number}
          show={true} onHideClick={this.props.onHideClick}>
          <div className="Imagebrowseritem-Edit">
            <h2><Trans>HEADLINE_EDIT_IMAGE</Trans></h2>
            <div className="Imagebrowseritem-Edit-Image">
              {
                this.props.onZoomClick
                  ? <Icon
                    onClick={() => this.props.onZoomClick(this.props.number)} size="large"
                    type="im"
                    imClassName="im-magnifier"
                  />
                  : null
              }
              <img alt={this.props.image.filename} src={this.props.image.thumbnailUrl}/>
            </div>
            <strong><Trans>LABEL_FILENAME</Trans></strong>: {this.props.image.filename}<br/>
            <strong><Trans>LABEL_FILESIZE</Trans></strong>: {LayerEditImage.formatBytes(this.props.image.size, 2)}<br/>
            <strong><Trans>LABEL_DIMENSIONS</Trans></strong>: {this.props.image.width} x {this.props.image.height} px<br/>
            <strong><Trans>LABEL_UPLOADED</Trans></strong>: {this.props.image.createdAt ? dayjs(this.props.image.createdAt).locale(this.props.i18n.language).format('L LT') : '-'}<br/>
            <React.Fragment>
              <br/>
              <ImageRoomAssigner image={this.props.image} rooms={this.props.rooms}
                                 roomAttributes={this.props.roomAttributes}
                                 onImageChanged={this.props.onImageChanged}
                                 galleries={this.props.galleries}
                                 onGalleriesChange={this.props.onGalleriesChange}
              />
            </React.Fragment>
            <React.Fragment>
              <br/>
              <EditImageInformation
                onSave={this.props.onHideClick}
                image={this.props.image}
                onImageChanged={this.props.onImageChanged}
                galleries={this.props.galleries}
              />
            </React.Fragment>
          </div>
        </Layer>
        : null
    )
  }

  static formatBytes (bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes'
    }
    let k = 1000,
      dm = decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  }
}

LayerEditImage.propTypes = {
  image: PropTypes.object,
  rooms: PropTypes.array.isRequired,
  roomAttributes: PropTypes.object.isRequired,
  number: PropTypes.number,
  permissions: PropTypes.object.isRequired,
  onImageChanged: PropTypes.func.isRequired,
  onZoomClick: PropTypes.func,
  onHideClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  onGalleriesChange: PropTypes.func.isRequired,
  galleries: GALLERIES_SHAPE.isRequired,
}
export default withTranslation()(LayerEditImage)
